module.exports = __webpack_public_path__ + "img/banner.ad9b669d.png";